// @flow
import { useEffect, useMemo } from 'react';

import * as activityTypes from './activity-types';
import getActivitySubmitter from './activity-submitters';
import getActivityParser from './activity-parsers';


type ActivityType = $Values<typeof activityTypes>

export default function useActivity(activityType: ActivityType, activityInputData: any) {
  const [activityParser, activitySubmit] = useMemo(() => [
    getActivityParser(activityType),
    getActivitySubmitter(/* activityType */),
  ], [activityType]);
  const eventTrigger = activityParser(activityInputData);

  useEffect(() => {
    activitySubmit(eventTrigger);
  }, [eventTrigger]);
}
